import { useState } from '@wordpress/element';
import classNames from 'classnames';
import Map from '../map';
import { getImages, getListprice } from '../../pages/accommodations';
import { findBlockByName } from '../../helpers/blockHelpers';
import './styles.scss';
const ListMap = ({
    isLoading,
    hoverId,
    posts,
    page
}) => {

    const [mapView, toggleMapView] = useState(false);

    if (!posts) {
        return null;
    }

    const getMarkers = postItem => {
        if (!postItem || !postItem.blocks) {
            return null;
        }

        const articleMapBlock = findBlockByName('dalslandskanal-custom-blocks/article-map', postItem.blocks);
        if (!articleMapBlock) {
            return null;
        }

        const attrs = articleMapBlock.attrs;
        if (!attrs) {
            return null;
        }

        if (!attrs.latitude && !attrs.longitude) {
            return null;
        }

        return {
            id: postItem.id,
            isHover: postItem.id === hoverId,
            latitude: attrs.latitude,
            longitude: attrs.longitude,
            title: postItem.title.rendered,
            images: getImages(postItem),
            text: getListprice(postItem),
            category: window.siteTitle ? window.siteTitle.site_title : null,
            link: postItem.link
        }
    };

    let markers = [];

    posts.forEach(post => {
        markers = [...markers, getMarkers(post)];
    });

    markers = markers.filter(f => f !== null);

    return (
        <div className={classNames({
            'list-map': true,
            'list-map--is-map-view': mapView
        })}>
            <div className="list-map__container">
                <Map markers={markers} usePopup={true} page={page} hoverId={hoverId} />
            </div>
            <div className="list-map__container-toggler">
                <button 
                    type="button" 
                    className={classNames({
                        'list-map__toggle': true,
                        'list-map__toggle--is-map-view': mapView
                    })}
                    onClick={() => {
                        toggleMapView(!mapView);
                    }}>{mapView ? 'Lista' : 'Karta'}</button>
            </div>
        </div>
    );
};

export default ListMap;